import React from "react";
import { Link } from "react-router-dom";
import { branding } from "@/config/branding";
import { BrandLogo } from "@/components/BrandLogo";

// Split-screen shell for the auth pages (login/register/forgot/reset).
export default function AuthShell({ title, subtitle, children }: {
  title: string; subtitle?: string; children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <div className="hidden w-1/2 flex-col justify-between bg-slate-900 p-12 lg:flex">
        <Link to="/" className="flex items-center">
          <BrandLogo className="h-9" />
        </Link>
        <div>
          <h2 className="font-display text-4xl font-semibold leading-tight text-white">{branding.tagline}</h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-400">{branding.shortTagline}</p>
        </div>
        <div className="flex gap-8 text-slate-400">
          <div><p className="font-display text-2xl font-semibold text-white">24/7</p><p className="text-sm">Call answering</p></div>
          <div><p className="font-display text-2xl font-semibold text-white">SMS + Voice</p><p className="text-sm">Unified inbox</p></div>
          <div><p className="font-display text-2xl font-semibold text-white">Auto-book</p><p className="text-sm">Real availability</p></div>
        </div>
      </div>
      <div className="flex w-full items-center justify-center px-4 py-10 lg:w-1/2">
        <div className="w-full max-w-sm">
          <Link to="/" className="mb-8 flex items-center lg:hidden">
            <BrandLogo className="h-9" />
          </Link>
          <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
